<template>
    <div>
        <p class="loading text-center pt-5" v-if="loader.firstLoading">
            <i class="fas fa-spinner fa-spin" style="font-size:2rem"></i>
        </p>

        <div v-else>
            <div v-if="loader.rows.length">

                <base-table type="hover" :data="loader.rows">

                    <template slot="columns">
                        <th width="50px"></th>
                        <th>{{ $t('xapi.common.profile-id') }} / {{ $t('xapi.common.type') }}</th>
                        <th>{{ $t('xapi.common.activity-id') }}</th>
                    </template>

                    <template slot-scope="{row}">

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            @click="open(row)" 
                            class="td-actions"
                        >
                            <div class="index text-warning">
                                {{ row.index }}
                            </div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            {{ row.profile_id }}
                            <div><small>{{ row.profile_type }}</small></div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            <div><small>{{ row.activity_id }}</small></div>
                        </td>

                    </template>

                </base-table>

                <div slot="footer" class="text-center mt-3" v-if="loader.hasMore()">
                    <base-button round type="primary" :loading="loader.nextLoading" @click="loader.nextLoad()">
                        {{ $t('common.load-more') }}
                    </base-button>
                </div>

            </div>
            
            <div v-else>
                <p class="text-center pt-3">{{ $t('xapi.common.search.no-result') }}</p>
            </div>

        </div>

        <portal to="modals">

            <modal class="fullscreen" :title="'#'+index" title-color="warning" v-model="modals.viewer">
                <json-viewer :data="selected"></json-viewer>
            </modal>

        </portal>
    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        data() {
            return {
                loader: this.$xapi.loaders.activityProfiles,
                filters: this.$xapi.filters.activityProfiles,
                modals: new ModalsController('viewer'),
                hovered: null,
                selected: null,
                index: null,
            }
        },

        created() {
            this.loader.setMapData(this.mapData)
            this.loader.firstLoad()
        },

        methods: {

            mapData(item, index) {
                return {
                    index: index + 1,
                    data: item.data.content,
                    profile_id: item.profile_id,
                    profile_type: item.data.type,
                    activity_id: item.activity_id,
                }
            },

            open(row) {
                if (row.profile_type == 'application/json') {
                    this.selected= row.data
                    this.index = row.index
                    this.modals.open('viewer')
                }
            }
        }
    }
</script>

<style scoped>

    td:hover {
        cursor: pointer;
    }
    td .index {
        width: 30px;
        height: 30px;
        text-align: center;
        padding-top: 5px;
    }

</style>